import React, { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import Icons from '../../../assets/icons/index'
import styled from './RequestProductList.module.css'
import { useSelector } from "react-redux"
import callApi from "../../../services/api/apiClient"
import LoadingComponent from "../../../components/loading/LoadingComponent"
import ModalProvider from "../../../components/modal/ModalProvider"
import moment from 'moment'

const RequestProductList = () => {
    const navigate = useNavigate()
    const [isCancel, setIsCancel] = useState(false)
    const [orderId, setOrderId] = useState(null)
    const [requestList, setRequestList] = useState([])
    const [selectId, setSelectId] = useState(null)

    const userdata = useSelector(state => state?.user?.profile?.data);

    useEffect(() => {
        getRequestProduct()
        getUserInfo()
    }, []);

    const getUserInfo = () => {
        callApi('user/profile').loadingGroup('HomePageLoading').executeDispatch()
    }

    const statusColor = (status) => {
        switch (status) {
            case 'pending': return { color: '#FF6B0040', name: 'Pending', textColor: '#FF6B00' };
            case 'reviewed': return { color: '#01D28740', name: 'Reviewed', textColor: '#01D287' };
            default: return { color: '#5C5C5C40', name: 'Cancelled', textColor: '#5C5C5C' }
        }
    }

    const getRequestProduct = () => {
        let param = {
            page_no: 1,
            per_page: 10,
            transfer_type: 'request_to_main',
            // myTransfers: userdata?.user_group?.is_main_group ? false : true
        };

        callApi('transfer/getProductRequestTransfer')
            .withParam(param)
            .loadingGroup('requestproduct')
            .execute()
            .then(res => {
                console.log(res, "product List....")
                if (res?.data?.length >= 0) {
                    setRequestList(res?.data)
                }
            });
    }

    const onCancelRequest = () => {
        callApi('transfer/cancelRequest')
            .withKeyParameter({ id: selectId })
            .execute()
            .then(res => {
                if (res?.status === 'success') {
                    getRequestProduct()
                } else {
                    console.log("ERROR", res?.error)
                }
                setIsCancel(false)
            });
    }


    return (
        <div className={styled.list_container}>
            <LoadingComponent>
                <div className="flex items-center" onClick={() => {
                    navigate('/add_to_cart')
                }}>
                    <img src={Icons.back} alt="" className="w-[24px] h-[24px]" />
                    <p className={styled.title}>Request Product List</p>

                    {/* <div className={styled.amount_container}>
                        <span className={`${styled.amount} font-interRegular`}>Total Sale Amount : </span>
                        <span className={`${styled.amount} font-interSemiBold`}>{saleOrderList?.total_amount}</span>
                    </div> */}
                </div>
                {
                    requestList?.length > 0 ?
                        <table className="flex-1 table-auto w-full mt-[40px]">
                            <thead className="text-left">
                                <tr className={styled.table_header_row}>
                                    <th className="">Request No.</th>
                                    <th>Customer</th>
                                    <th>Date</th>
                                    <th>Request</th>
                                    <th>Status</th>
                                    <th className="w-2/12"></th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    requestList?.map((item, index) => (
                                        <tr className="h-[57px] border-b border-b-black-2" key={index}>
                                            <td className={`${styled.table_body_column} font-interSemiBold`}>
                                                <span className="cursor-pointer">{item?.name}</span>
                                            </td>
                                            <td className={`${styled.table_body_column} font-interRegular`} onClick={() => {
                                                navigate(`/request_product_detail/${item?.id}`)
                                            }}>{item?.request_partner?.name}</td>
                                            <td className={`${styled.table_body_column} font-interRegular`}>{moment(item?.request_date).format('DD MMMM YYYY')}</td>
                                            <td className={`${styled.table_body_column} font-interRegular`}>{item?.delivery_type === 'pickup' ? 'Pickup' : 'Delivery'}</td>
                                            <td className={styled.table_body_column}>
                                                <div className={styled.statusBtn} style={{ backgroundColor: statusColor(item?.status)?.color }}>
                                                    <p className={styled.statusText} style={{ color: statusColor(item?.status)?.textColor }}>{statusColor(item?.status)?.name}</p>
                                                </div>
                                            </td>

                                            {!userdata?.user_group?.is_main_group && item?.status === 'pending' ?
                                            <td className={styled.table_body_column}>
                                                <button className={styled.cancelBtn} onClick={() => {
                                                    setSelectId(item?.id)
                                                    setIsCancel(true)
                                                }}>
                                                    <p className="text-xs text-red-3">Cancel</p>
                                                </button>
                                            </td> : <td></td>
                                            }

                                            <td className="w-1/12"></td>
                                        </tr>
                                    ))
                                }
                            </tbody>
                        </table>
                        :
                        <div className="flex justify-center items-center h-full">
                            <p className={styled.not_found}>There is not data.</p>
                        </div>
                }
            </LoadingComponent>

            <ModalProvider
                isOpen={isCancel}
                onClose={() => setIsCancel(false)}
                title={'Cancel Product Request'}
                cancelBtn={() => setIsCancel(false)}
                sendBtn={() => onCancelRequest()}
                description={'Are you sure you want to  cancel request product?'} />
        </div>
    )
}
export default RequestProductList